import { FormSection } from "components/MainSectionTemplate/types";
import { YesNoRadioGroupForInPageEditing, YesNoText } from "components/ValidatedFields/YesNoRadioGroup";
import React from "react";

interface Props {
  instruction: server.dto.UpdateClientConfigurationInstruction
}

export const ProductionSection = (props: Props): FormSection => {
  return {
    key: "productionSettings",
    type: "regular",
    title: RESX.Tour.resxTour,
    fields: [{
      key: "production_enabled",
      label: RESX.EmbedWizard.Display,
      render: () => <YesNoText value={props.instruction.tourEnabled} />,
      inPageEdit: {
        render: ({ onChange }) => <YesNoRadioGroupForInPageEditing
          value={props.instruction.tourEnabled}
          onChange={(v) => onChange(v, true)}
        />,
        type: "custom",
        initialValue: props.instruction.tourEnabled,
        submitChange: (value: boolean) => {
          return window.CoreApi.ClientConfiguration.Update({ ...props.instruction, tourEnabled: value });
        }
      }
    }]
  }
}